
import { useState, useEffect } from 'react';
import { Phone, MapPin } from 'lucide-react';
import ContactForm from './ContactForm';

const CallToAction = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    const handleScroll = () => {
      const element = document.getElementById('call-to-action');
      if (element) {
        const position = element.getBoundingClientRect();
        if (position.top < window.innerHeight * 0.75) {
          setIsVisible(true);
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Check initial position
    
    // Check if the URL hash indicates we should scroll to this section
    setTimeout(() => {
      if (window.location.hash === '#contact') {
        const element = document.getElementById('call-to-action');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          setIsVisible(true);
        }
      }
    }, 500);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="call-to-action" className="py-24 bg-gradient-to-b from-white to-slate-50">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-start">
            <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <h2 className="text-4xl md:text-5xl font-bold text-abbella-ebony mb-8">
                Ready to experience the FlowCare difference?
              </h2>
              <p className="text-xl text-slate-600 mb-10">
                Get in touch today to learn how our flexible, personalized care can support you or your loved ones.
              </p>
              
              <div className="space-y-6 mb-10">
                <div className="flex items-center gap-4">
                  <Phone className="w-6 h-6 text-abbella-aqua" />
                  <span className="text-xl font-medium text-abbella-ebony">(410) 983-9942</span>
                </div>
                <div className="flex items-start gap-4">
                  <MapPin className="w-6 h-6 text-abbella-aqua flex-shrink-0 mt-1" />
                  <span className="text-xl font-medium text-abbella-ebony">600 Owings Mills Blvd, Suite 440<br />Owings Mills, MD 21117</span>
                </div>
              </div>
            </div>
            
            <div className={`transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
